import '../../../sass/screens/sign_in/index.scss';

import { initializeForm } from '../../utils/form';
import { validateEmail, validatePassword } from '../../utils/validators';
import { initializeRecaptcha } from '../../utils/recaptcha';

$(() => {
  const singInFormSelector = $('#sign-in-form');

  initializeRecaptcha();

  initializeForm(singInFormSelector, {
    preventDefault: false,
    validate: (values) => {
      const errors = {
        ...validateEmail(values),
        ...validatePassword(values),
      };
      return errors;
    },
  });
});
